import React from "react"
import skills from "../data/skills"

const Skills = () => {
  return (
    <section className="skills_area" id="skills">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="main_title">
              <h2>Skills</h2>
              <p>My Technical Level</p>
            </div>
          </div>
        </div>
        <div className="skill_inner">
          {skills &&
            skills.map((skill) => (
              <div className="skill_item" key={skill.id}>
                <img src={skill.icon} alt={skill.title} className="icon" />
                <h4>{skill.title}</h4>
                <p>{skill.description}</p>
                <div className="skills">
                  {skill.skills &&
                    skill.skills.map((tech) => (
                      <div className="skill" key={tech.id}>
                        <img src={tech.icon} alt={tech.label} />
                        <span>{tech.label}</span>
                      </div>
                    ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Skills
